// extracted by mini-css-extract-plugin
export var downArrow = "_81-0";
export var infoTooltipIcon = "_81-3";
export var label = "_81-1";
export var optionCard = "_81-4";
export var upArrow = "_81-2";